import AUTH_ACTIONS from '../actions/authAction';


export default function reducer(state, action){
  switch(action.type){
    case AUTH_ACTIONS.SET_LOGGED_USER_DATA:
      return {
        ...state,
        userData: action.value
      }
    case AUTH_ACTIONS.RECEIVE_CONFIRMATION_PIN_DATA:
      return {
        ...state,
        phoneConfirmation: action.value
      }
    case AUTH_ACTIONS.SET_LOGGED_USER_PHONE:
      return {
        ...state,
        userData: {
          ...state.userData,
          phone: action.value
        }
      }
    case AUTH_ACTIONS.RECEIVE_USER_BANK_ACCOUNT:
      return {
        ...state,
        userBankAccount: action.value
      }
    case AUTH_ACTIONS.SET_USER_EXTRA_DATA:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.value
        }
      }
    default: 
      return state;
  }
};

export const authInitialState = {
  userData: {},
  phoneConfirmation: {},
  userBankAccount: {}
}